export default __webpack_public_path__ + "static/media/three-dots.dd1e78e5.svg";